/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { initConfig, initLocalConfig } from './app/app.module';
import { provideAppInitializer, inject, importProvidersFrom } from '@angular/core';
import { AppConfigService } from './app/core/services/app-config.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppInterceptor } from './app/core/interceptor/app-interceptor';
import { LoggerService } from './app/shared/services/logger.service';
import { DatePipe } from '@angular/common';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { AppRoutingModule } from './app/app-routing.module';
import { CoreModule } from './app/core/core.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MatNativeDateModule } from '@angular/material/core';
import { AppComponent } from './app/app.component';


bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, AppRoutingModule, CoreModule, NgbModule, MatNativeDateModule),
        provideAppInitializer(() => {
            const initializerFn = (initConfig)(inject(AppConfigService));
            return initializerFn();
        }),
        provideAppInitializer(() => {
            const initializerFn = (initLocalConfig)(inject(AppConfigService));
            return initializerFn();
        }),
        { provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true }, LoggerService, DatePipe,
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations()
    ]
})
  .catch(err => console.error(err));
